import { Helmet } from "react-helmet-async";
import BreadCrumbs from "../components/BreadCrumbs/BreadCrumbs";
import { GrLocation } from "react-icons/gr";
import { FiPhone } from "react-icons/fi";
import { MdOutlineMail } from "react-icons/md";

const Contact = () => {


  return (
    <section>
      <div className="about-mijsc-section w-full bg-cover h-fit pb-5">
        {/* SEO */}
        <Helmet>
          <title>Contact Us | LMP</title>
          <meta
            name="description"
            content="Contact Mizuho India Japan Study Centre (MIJSC), Indian Institute of Management Bangalore."
          />
        </Helmet>

        <BreadCrumbs />

        <div className="w-[94%] mx-2 md:mx-4 mt-10 md:ml-8 md:mt-20 text-justify md:flex md:px-0  mb-20 bg-white shadow-2xl">
          {/* LEFT CONTENT */}
          <section className="md:w-[40%] h-fit mb-5 px-10">
            <p className="text-gray-600 py-1 text-sm sm:text-sm mt-2">
              <div className="flex gap-2 items-center">
                <GrLocation className="text-green-600 text-xl" />
                <p> Mizuho India Japan Study Centre (MIJSC) </p>
              </div>
              <p className="md:px-7 pl-7 py-1 md:text-base text-sm">Indian Institute of Management Bangalore Bannerghatta Road, Bangalore - 560076 </p>
            </p>
            <div className="flex gap-2 items-center">
              <FiPhone className="text-green-600 text-xl" />
              <a
                href="tel:+919741376645"
                className="text-white text-sm hover:underline"
              ><p className="text-gray-600 py-1 text-sm sm:text-base">Phone No - 9741376645 </p> </a>
            </div>
            <div className="flex gap-2 items-center">
              <MdOutlineMail className="text-green-600 text-xl" />
              <a
                href="mailto:contact@mijsc.iimb.ac.in"
                className="text-white text-sm"
              ><p className="text-gray-600 py-1 text-sm sm:text-base">mijsc@iimb.ac.in </p></a>
            </div>


            <div className="w-full h-fit py-5 ">
              <div className="bg-gray-100 shadow-md rounded-md w-full h-[450px]">
                <h2 className="md:text-xl text-lg py-2 text-green-600 font-semibold pt-7 px-3">
                  Enquiry Form
                </h2>
                <form className="flex flex-col gap-4 mt-4 px-4 text-xs">
                  {/* Name */}
                  <div>
                    <label className="block text-gray-700  text-xs mb-1">
                      Name
                    </label>
                    <input
                      type="text"
                      placeholder="Enter your name"
                      className="w-full border border-gray-300 rounded-md px-3 py-1 focus:outline-none focus:ring-2 focus:ring-green-600"
                    />
                  </div>

                  {/* Email */}
                  <div>
                    <label className="block text-gray-700 text-xs font-medium mb-1">
                      Email
                    </label>
                    <input
                      type="email"
                      placeholder="Enter your email"
                      className="w-full border border-gray-300 rounded-md px-3 py-1 focus:outline-none focus:ring-2 focus:ring-green-600"
                    />
                  </div>

                  {/* Phone */}
                  <div>
                    <label className="block text-gray-700 text-xs font-medium mb-1">
                      Phone
                    </label>
                    <input
                      type="tel"
                      placeholder="Enter your phone number"
                      className="w-full border border-gray-300 rounded-md px-3 py-1 focus:outline-none focus:ring-2 focus:ring-green-600"
                    />
                  </div>

                  {/* Message */}
                  <div>
                    <label className="block text-gray-700 text-xs font-medium mb-1">
                      Message
                    </label>
                    <textarea
                      placeholder="Enter your message"
                      rows={4}
                      className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-green-600"
                    ></textarea>
                  </div>

                  {/* Submit Button */}
                  <button
                    type="submit"
                    className="bg-green-600 text-white font-semibold px-5 py-2 rounded-md hover:bg-green-700 transition-colors"
                  >
                    Submit
                  </button>
                </form>

              </div>
            </div>
          </section>

          {/* RIGHT MAP */}
          <section className="md:w-[60%] h-[665px] relative">
            <iframe
              title="Mizuho India Japan Study Centre Location"
              src="https://www.google.com/maps?q=Mizuho%20India%20Japan%20Study%20Centre%20Indian%20Institute%20of%20Management%20Bangalore&output=embed"
              className="mt-26 w-[100%] h-full border-0  shadow-md"
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </section>
        </div >
      </div >
    </section >
  );
};

export default Contact;